import { roomConfigs } from '../config.js';

function getRoomPath(room) {
  const pathTemplate = roomConfigs[room.path].path;
  if ("params" in room) {
    return pathTemplate.replace(/{(\w+)}/g, (_, key) => room.params[key] || "");
  }
  return pathTemplate;
}

export { getRoomPath };
//# sourceMappingURL=getRoomPath.js.map
